import { IMajorTech } from "../../models/MajorTech";

export const EmptyMajorTech: IMajorTech = {
  req_CategoryID: undefined,
  req_CategoryName: "",
  req_CategoryStatus: true,
  req_CategoryDescription: "",
  allocateByRecruiterHead: false,
  allocateByTeamLead: false,
  recruiterAllocationAuto: false,
  parent_ID: 0,
  sub_Category: false,
  is_Across_Company:false,
}